import React, { Component } from 'react';
import { Link } from 'react-router';

import SocialLinkItem from '../../SocialLinkItem';
export default class SocialLinks extends Component {

  render() {
    const { } = this.props;

    return (
      <div className="SocialLinks">

      	<div className="SocialLinks__row">
	      	<SocialLinkItem 
	      		url="https://blacksquare.nyc3.digitaloceanspaces.com/moose_almighty/moose_almighty/icons/icon_spotify_blue.png"
	      		name="Spotify" 
	      		link="https://open.spotify.com/artist/24r28WlEze44ZfRyJCTykU?si=9zHqsO1xTAGTU1Az5ucMQg"
	      	/>
      		
      		<SocialLinkItem 
	      		url="https://blacksquare.nyc3.digitaloceanspaces.com/moose_almighty/moose_almighty/icons/icon_bandcamp_blue.png"
	      		name="Bandcamp" 
	      		link="http://www.moosealmighty.bandcamp.com"
	      	/>	

	      	<SocialLinkItem 
	      		url="https://blacksquare.nyc3.digitaloceanspaces.com/moose_almighty/moose_almighty/icons/icon_apple_blue.png"
	      		name="Apple Music" 
	      		link="https://music.apple.com/us/artist/moose-almighty/1456334456"
	      	/>

	      	<SocialLinkItem 
	      		url="https://blacksquare.nyc3.digitaloceanspaces.com/moose_almighty/moose_almighty/icons/icon_youtube_blue.png"
	      		name="Youtube" 
	      		link="https://www.youtube.com/channel/UCswARUsQRIkZi2vD5YUg6ww"
	      	/>
	      </div>
	      <div className="SocialLinks__row">

	      	<SocialLinkItem 
	      		url="https://blacksquare.nyc3.digitaloceanspaces.com/moose_almighty/moose_almighty/icons/icon_instagram_blue.png"
	      		name="Instagram" 
	      		link="https://www.instagram.com/moosealmightyband/"
	      	/>

	      	<SocialLinkItem 
	      		url="https://blacksquare.nyc3.digitaloceanspaces.com/moose_almighty/moose_almighty/icons/icon_facebook_blue.png"
	      		name="Facebook" 
	      		link="https://www.facebook.com/moosealmightymusic"
	      	/>

	      	<SocialLinkItem 
	      		url="https://blacksquare.nyc3.digitaloceanspaces.com/moose_almighty/moose_almighty/icons/icon_twitter_blue.png"
	      		name="Twitter" 
	      		link="https://twitter.com/moose_almighty"
	      	/>

	      </div>
      </div>    
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Sections/SocialLinks/SocialLinks.js